module.exports = __webpack_public_path__ + "static/media/StartMobileBg.410ab96f.png";


//////////////////
// WEBPACK FOOTER
// ./src/StartMobileBg.png
// module id = 541
// module chunks = 0